import { fontStyles } from './font-styles/font-styles.js';
import { focusStyles } from './focus-styles/focus-styles.js';
import { themeColor } from './theme-color/theme-color.js';
import { linearGradient, radialGradient } from './gradient/gradient.js';
import { smallerThan, largerThan } from './breakpoints/breakpoints.js';
import { rgba } from './rgba/rgba.js';
import { size } from './size/size.js';
import { cover } from './cover/cover.js';
import { darken } from './darken/darken.js';
import { lighten } from './lighten/lighten.js';
import { radius } from './radius/radius.js';
import { variant } from './variant/variant.js';
import { primaryShade } from './primary-shade/primary-shade.js';
import { hover } from './hover/hover.js';

const fns = {
  fontStyles,
  themeColor,
  focusStyles,
  linearGradient,
  radialGradient,
  smallerThan,
  largerThan,
  rgba,
  size,
  cover,
  darken,
  lighten,
  radius,
  variant,
  primaryShade,
  hover
};

export { fns };
//# sourceMappingURL=index.js.map
